import React from 'react';
import { Phone, MessageCircle, Check, Users, Infinity } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { toast } from 'sonner';

const ContactSecretary = () => {
  const phoneNumber = '+34742030476';
  const phoneDisplay = '+34 742 03 04 76';

  const handleCall = () => {
    toast.success('Iniciando llamada...', {
      description: 'Conectando con nuestra secretaria',
      icon: <Phone size={18} />
    });
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    toast.success('Abriendo WhatsApp...', {
      description: 'Te redirigimos a WhatsApp para contactar con nuestra secretaria',
      icon: <MessageCircle size={18} />
    });
    const message = encodeURIComponent('Hola, me gustaría reservar una cita con Raúl.');
    setTimeout(() => {
      window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
    }, 500);
  };

  return (
    <section id="reservas" className="py-16 md:py-24 bg-[var(--bg-section)]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Título */}
          <h2 className="heading-1 mb-4">Reserva tu consulta</h2>
          <p className="body-large text-[var(--text-light)] mb-12 max-w-2xl mx-auto">
            Contacta con nuestra secretaria para agendar tu cita. Disponible de lunes a viernes de 10:00 a 14:00 y de 16:00 a 20:00.
          </p>

          {/* Card principal */}
          <Card className="network-card">
            <CardHeader className="pb-8">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[var(--brand-primary)] flex items-center justify-center">
                <Phone size={40} className="text-[var(--brand-dark)]" />
              </div>
              <CardTitle className="heading-2 mb-3">Llama o escribe por WhatsApp</CardTitle>
              <CardDescription className="body-large">
                Nuestra secretaria te atenderá personalmente para gestionar tu reserva
              </CardDescription>
            </CardHeader>
            
            <CardContent className="space-y-6">
              {/* Número de teléfono destacado */}
              <div className="bg-[var(--bg-subtle)] rounded-2xl p-6">
                <p className="text-sm text-[var(--text-light)] mb-2">Teléfono de contacto:</p>
                <p className="text-3xl md:text-4xl font-bold text-[var(--brand-dark)] mb-4">
                  {phoneDisplay}
                </p>
              </div>

              {/* Botones de acción */}
              <div className="grid md:grid-cols-2 gap-4">
                <Button 
                  className="btn-primary w-full py-6 text-lg"
                  onClick={handleCall}
                >
                  <Phone className="mr-3 h-6 w-6" />
                  Llamar ahora
                </Button>
                
                <Button 
                  className="btn-secondary w-full py-6 text-lg"
                  onClick={handleWhatsApp}
                >
                  <MessageCircle className="mr-3 h-6 w-6" />
                  WhatsApp
                </Button>
              </div>

              {/* Información adicional */}
              <div className="bg-[var(--bg-subtle)] rounded-2xl p-6 mt-8">
                <h4 className="body-medium font-semibold mb-3 text-[var(--brand-dark)]">
                  ¿Qué necesitas para tu cita?
                </h4>
                <ul className="space-y-2 body-small text-[var(--text-light)] text-left">
                  <li className="flex items-center gap-2">
                    <Check size={16} className="text-green-600" />
                    Tu nombre completo
                  </li>
                  <li className="flex items-center gap-2">
                    <Check size={16} className="text-green-600" />
                    Fecha y hora preferida
                  </li>
                  <li className="flex items-center gap-2">
                    <Check size={16} className="text-green-600" />
                    Motivo de la consulta
                  </li>
                </ul>
              </div>

              {/* Precios */}
              <div className="border-t border-[var(--border)] pt-6">
                <h4 className="body-medium font-semibold mb-4 text-[var(--brand-dark)]">
                  Tarifas
                </h4>
                <div className="grid sm:grid-cols-3 gap-4 text-center">
                  <div className="bg-[var(--bg-subtle)] rounded-xl p-4">
                    <p className="text-2xl font-bold text-[var(--brand-dark)] mb-1">50€</p>
                    <p className="body-small text-[var(--text-light)]">Sesión individual</p>
                  </div>
                  <div className="bg-[var(--bg-subtle)] rounded-xl p-4">
                    <p className="text-2xl font-bold text-[var(--brand-dark)] mb-1">140€</p>
                    <p className="body-small text-[var(--text-light)]">Bono 3 sesiones</p>
                  </div>
                  <div className="bg-[var(--bg-subtle)] rounded-xl p-4">
                    <p className="text-2xl font-bold text-[var(--brand-dark)] mb-1">220€</p>
                    <p className="body-small text-[var(--text-light)]">Bono 5 sesiones</p>
                  </div>
                </div>
                <p className="body-small text-[var(--text-light)] mt-4 flex items-center justify-center gap-4">
                  <span className="inline-flex items-center gap-1">
                    <Users size={14} />
                    Compartibles
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <Infinity size={14} />
                    Sin caducidad
                  </span>
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSecretary;
